import MobileMenu           from '../components/mobileMenu';
import MegaMenu             from '../components/megaMenu';
import Accordion            from '../components/accordion';
import GridCarousel         from '../components/grid';
import TestimonialCarousel  from '../components/testimonials';
import LogoSlider           from '../components/logoSlider';
import Form                 from '../components/form';
import Video                from '../components/video';

export default {
  init() {
    // JavaScript to be fired on all pages
    const navMenu       = document.querySelector('.navbar');
    const accordions    = document.querySelectorAll('.accordion');
    const grids         = document.querySelectorAll('.grid');
    const testimonials  = document.querySelectorAll('.testimonials');
    const logoSliders   = document.querySelectorAll('.logo-slider');
    const forms         = document.querySelectorAll('form');
    const videos        = document.querySelectorAll('.video');

    if (forms) {
      forms.forEach((form) => {
        new Form(form);
      });
    }

    if (navMenu) {
      new MobileMenu(navMenu);
      new MegaMenu(navMenu);
    }

    if (accordions) {
      new Accordion(accordions);
    }

    if (grids) {
      new GridCarousel(grids);
    }

    if (testimonials) {
      new TestimonialCarousel(testimonials);
    }

    if (logoSliders) {
      new LogoSlider(logoSliders);
    }

    if (videos) {
      new Video(videos);
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
